import { apiUrl } from '../utils/api-url';

export interface CostLineItem {
  name: string;
  serviceType: string;
  sku: string;
  quantity: number;
  unitPriceMonthly: number;
  totalMonthly: number;
  pricingTier: string;
  source: string;
  workloadId?: string;
}

export interface CostCategory {
  name: string;
  lineItems: CostLineItem[];
  subtotalMonthly: number;
}

export interface EngagementCostEstimate {
  projectId: string;
  region: string;
  currency: string;
  generatedAt: string;
  savingsPlanPhase: string;
  categories: CostCategory[];
  azureConsumptionMonthly: number;
  w365LicensingMonthly: number;
  grandTotalMonthly: number;
  notes: string[];
}

export async function generateEstimate(
  projectId: string, customerId: string, token: string,
  region?: string, currency?: string, savingsPlanPhase?: string
): Promise<EngagementCostEstimate> {
  const res = await fetch(apiUrl('/api/costs/estimate'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ projectId, customerId, region, currency, savingsPlanPhase }),
  });
  if (!res.ok) throw new Error(`Failed to generate estimate: ${res.status}`);
  return res.json();
}

export async function getCachedEstimate(
  projectId: string, customerId: string, token: string
): Promise<EngagementCostEstimate | null> {
  const res = await fetch(
    apiUrl(`/api/costs/estimate/${projectId}?customerId=${encodeURIComponent(customerId)}`),
    { headers: { Authorization: `Bearer ${token}` } }
  );
  if (res.status === 404) return null;
  if (!res.ok) throw new Error(`Failed to get estimate: ${res.status}`);
  const artifact = await res.json();
  return artifact.data ?? artifact;
}
